module.exports = __webpack_public_path__ + "img/astral_11.82f4d4a5.svg";